import {
    GET_ORDERS,
    LOAD_MORE_ORDERS,
    ADD_TO_ORDERS,
    EDIT_ORDER,
    SET_ORDER_PICS,
    ADD_ORDER_PICS,
    DELETE_ORDER_PICS,
    
    
} from '../actions/types'

const initialState = {
    orders:[],
    pendingOrders:[],
    toPackOrders:[],
    toShipOrders:[],
    shippedOrders:[],
    cancelledOrders:[],
    orderPics:[],
    lastVisible: null

}

const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_ORDERS:
            var  orderArray = action.payload.orderArray
            var  lastVisible = action.payload.lastVisible

            var pending = orderArray.filter(item => item.status == 'Pending')
            var topack = orderArray.filter(item => item.status == 'To Pack')
            var toship = orderArray.filter(item => item.status == 'To Ship')
            var shipped = orderArray.filter(item => item.status == 'Shipped')
            var cancelled = orderArray.filter(item => item.status == 'cancelled')
            return {
                ...state,
                orders: orderArray,
                pendingOrders: pending,
                toPackOrders: topack,
                toShipOrders: toship,
                shippedOrders: shipped,
                cancelledOrders: cancelled,
                lastVisible:lastVisible 
            }
    case LOAD_MORE_ORDERS:
        var  orderArray = action.payload.orderArray
        var  lastVisible = action.payload.lastVisible
        // console.log(action.payload)
        var pending = orderArray.filter(item => item.status == 'Pending')
        var topack = orderArray.filter(item => item.status == 'To Pack')
        var toship = orderArray.filter(item => item.status == 'To Ship')
        var shipped = orderArray.filter(item => item.status == 'Shipped')
        var cancelled = orderArray.filter(item => item.status == 'cancelled')
        return {
            ...state,     
            orders: state.orders.concat(orderArray),
            pendingOrders: state.pendingOrders.concat(pending),
            toPackOrders: state.toPackOrders.concat(topack),
            toShipOrders: state.toShipOrders.concat(toship),
            shippedOrders: state.shippedOrders.concat(shipped),
            cancelledOrders: state.cancelledOrders.concat(cancelled),
            lastVisible:lastVisible 

        }
    case ADD_TO_ORDERS:
        // console.log(action.payload)
        var pending = action.payload.filter(item => item.status == 'Pending')
        var topack = action.payload.filter(item => item.status == 'To Pack')
        var toship = action.payload.filter(item => item.status == 'To Ship')
        var shipped = action.payload.filter(item => item.status == 'Shipped')
        var cancelled = action.payload.filter(item => item.status == 'cancelled')
        return {
            ...state,
            orders: action.payload.concat(state.orders),
            pendingOrders: pending.concat(state.pendingOrders),
            toPackOrders: topack.concat(state.toPackOrders),
            toShipOrders: toship.concat(state.toShipOrders),
            shippedOrders: shipped.concat(state.shippedOrders),
            cancelledOrders: cancelled.concat(state.cancelledOrders),
        }
    case EDIT_ORDER:
        // console.log(action.payload)
        var newOrderItem = action.payload
        var newOrders = state.orders.map(item => {
            if(item.order_id == newOrderItem.order_id){
                return(newOrderItem)
            }else{
                return(item)
            }
        })
        var pending = newOrders.filter(item => item.status == 'Pending')        
        var topack = newOrders.filter(item => item.status == 'To Pack')
        var toship = newOrders.filter(item => item.status == 'To Ship')
        var shipped = newOrders.filter(item => item.status == 'Shipped')
        var cancelled = newOrders.filter(item => item.status == 'cancelled')
       
        return {
            ...state,
            orders: newOrders,
            pendingOrders:pending,
            toPackOrders: topack,
            toShipOrders: toship,
            shippedOrders: shipped,
            cancelledOrders: cancelled
        }
    case SET_ORDER_PICS:
        return {
            ...state,
            orderPics: action.payload         
        }
    case ADD_ORDER_PICS:
        return {
            ...state,
            orderPics: state.orderPics.concat([action.payload ])         
        }
    case DELETE_ORDER_PICS:
        var newOrders = []
        state.orderPics.map(item=>{
            if(item.name !== action.payload){
                newOrders.push(item)
            }
        })
        return{
            ...state,
            orderPics: newOrders 

        }
                
    default: return state
    }
}

export default ordersReducer

